import { classNameBindings, classNames } from "@ember-decorators/component"
import Component from "@ember/component"
import { inject as service } from "@ember/service"

@classNames("date-annotation", "date-annotation--planbook-date")
@classNameBindings("annotation.attributes.isOff:is-off:is-on")
export default class DateAnnotationPlanbook extends Component.extend() {
  @service("ember-store")
  store

  @service
  appState
}
